import React from "react";

const MatterDetails = ({
  width,
  minWidth,
  matter,
  clear,
  className,
  showMatterRef = true,
}) => {
  const value = (v) => (clear ? "" : v || "");

  const appCode = matter?.appCode;

  const fields = [
    { label: "Client", value: value(matter?.clientName) },
    { label: "Branch", value: value(matter?.branch) },
    { label: "Fee Earner", value: value(matter?.feeEarnerName) },
    { label: "Supervisor", value: value(matter?.supervisorName) },
  ];

  return (
    <div
      className={`bg-white slim-scroll-x ${className ?? ""}`}
      style={{
        maxWidth: width,
        flex: "1 1 auto",
        minWidth: 0,
        padding: "8px 14px",
        borderRadius: "10px",
        boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
        overflowX: "auto",
      }}>
      <div style={{ minWidth: minWidth ?? "400px" }}>
        <div
          className="d-flex align-items-baseline mb-1"
          style={{ gap: "8px", lineHeight: 1.3 }}>
          {showMatterRef && (
            <span
              className="text-nowrap"
              style={{ fontSize: "0.8rem", color: "#707070" }}>
              {clear || !matter?.matterRef ? "Matter" : matter?.matterRef}
            </span>
          )}
          <span
            className="text-truncate"
            style={{ fontSize: "1rem", color: "#262626", fontWeight: 500 }}
            title={value(matter?.details)}>
            {value(matter?.details) || "-"}
          </span>
          {value(appCode) && (
            <span
              className="ms-auto text-nowrap"
              style={{
                fontSize: "0.8rem",
                padding: "1px 8px",
                borderRadius: "6px",
                background: "#e6f1fb",
                color: "#0c447c",
                fontWeight: 500,
              }}
              title="Application">
              {value(appCode)}
            </span>
          )}
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            columnGap: "24px",
          }}>
          {fields.map((f) => (
            <div
              key={f.label}
              className="d-flex fs-sm"
              style={{
                gap: "8px",
                padding: "3px 0",
                lineHeight: 1.3,
                borderTop: "0.5px solid rgba(171, 167, 167, 0.5)",
              }}>
              <span style={{ color: "#707070", minWidth: "5.5rem" }}>
                {f.label}
              </span>
              <span
                className="text-truncate"
                style={{ color: "#262626", fontWeight: 500 }}
                title={f.value}>
                {f.value || "-"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MatterDetails;
